// some default settings for all services can be included here

export const DEFAULT_HTTP_TIMEOUT = 25000; // (1000=1sec)
